import Actions from 'actions';

const initialState = Object.freeze({});

function favourite(state = initialState, action) {
  switch (action.type) {
    case Actions.FAVOURITE_ARTICLE_INFO_REQUEST:
      return initialState;
    case Actions.FAVOURITE_ARTICLE_INFO_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FAVOURITE_ARTICLE_INFO_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default favourite;
